import { StepSchema, StepType } from '@feedyou/schema'
import { deepOverwriteIds } from './object/object'
import { generateId } from './generateId'

export const getStepWithUniqueIds = (step: StepSchema) => {
  return deepOverwriteIds(step, () => generateId.stepId(), 'id')
}

export const isOfType =
  <T extends StepType>(type: T) =>
  (step?: StepSchema): step is Extract<StepSchema, { type: T }> => {
    return step?.type === type
  }

export const isOneOfTypes =
  <T extends StepType>(types: T[]) =>
  (step?: StepSchema): step is Extract<StepSchema, { type: T }> => {
    return !!step?.type && types.includes(step.type as T)
  }
